import React from 'react';
import student_lounge1 from '../../../Images/student_lounge1.jfif';
import student_lounge2 from '../../../Images/student-lounge2.jfif';
import student_lounge3 from '../../../Images/student-lounge3.jfif';
import student_lounge4 from '../../../Images/student-lounge4.jfif';


const Student_lounge = () => {
    return (
        <div className='mt-20 mb-10'>
        <h1 className='text-5xl font-bold text-center'>AIUB Student Lounge</h1>
        <div className="hero mt-10 mb-10">

            <div className="hero-content flex-col lg:flex-row">
                <div className='w-full grid lg:grid-cols-4  gap-5 '>
                    <img src={student_lounge1} alt='' className="" />
                    <img src={student_lounge2} alt='' className="" />
                    <img src={student_lounge3} alt='' className="" />
                    <img src={student_lounge4} alt='' className="" />
       
            
                </div>

            </div>
        </div>
        <div className=''>
            <p className="p-6 text-justify">In-house cafeteria and food carts bustling with variety of delicious and healthy options, catering to the needs of students and staff, from breakfast, lunch, and snacks throughout the day. The university cafeteria serves as a vital hub for students, faculty, and staff, providing not just sustenance but also fostering social interactions and promoting a sense of community.</p>
        </div>

    </div>
    );
};

export default Student_lounge;